<template>
  <div class="w preview1">
    <br />
    <br />
    <div ref="container" class="scroll_wrapper">
      <div class="container">
      <div class="models">
        <a-button style="padding: 0 8px; margin: 10px" type="primary">关联站房</a-button>
        <a-button style="padding: 0 8px; margin: 10px; background-color: #000334" type="primary" @click="changeComponent(1)" v-show="widgetShow">组态</a-button>
        <a-button style="padding: 0 8px; margin: 10px; background-color: #000334" type="primary" @click="changeComponent(2)" v-show="dataShow">数据</a-button>
        <a-button style="float: right; padding: 0 8px; margin: 10px" icon="fullscreen" @click="setFullscreen">全屏</a-button>
      </div>
      <div id="preview" ref="preview"></div>
      <div class="content">
        <div class="running_status">
          <div class="header">
            <h1 class="title">空压机运行状态</h1>
            <img src="../../../../assets/stationunitbox.jpg" alt="" />
          </div>
          <div class="pie">
            <div id="runningState"></div>
            <div class="description">
              <ul>
                <li>
                  <span>运行</span><strong>{{ runningStatus['online'] }}</strong>
                </li>
                <li>
                  <span>待机</span><strong>{{ runningStatus['待机'] }}</strong>
                </li>
                <li>
                  <span>离线</span><strong>{{ runningStatus['offline'] }}</strong>
                </li>
              </ul>
            </div>
          </div>
          <div class="footer">
            <img src="../../../../assets/border.png" alt="">
          </div>
        </div>
        <div class="fault">
          <div class="header">
            <h1 class="title">设备故障状态</h1>
            <img src="../../../../assets/stationunitbox.jpg" alt="" />
          </div>
          <div class="container">
            <div class="col">
              <img src="../../../../assets/stationunitrepair.png" alt="">
              <span class="name">预警</span>
              <span class="process-wrapper">
                <div class="process" :style="{ '--i': faultStatus['预警'] / faultStatus.faultTotal || 0 }"></div>
              </span>
              <em class="count">{{ faultStatus['预警'] }}</em>
            </div>
            <div class="col">
              <img src="../../../../assets/stationuniwarn.png" alt="">
              <span class="name">故障</span>
              <span class="process-wrapper">
                <div class="process" :style="{ '--i': faultStatus['error'] / faultStatus.faultTotal || 0 }"></div>
              </span>
              <em class="count">{{ faultStatus['error'] }}</em>
            </div>
            <div class="col">
              <img src="../../../../assets/time.png" alt="">
              <span class="name">保养到期</span>
              <span class="process-wrapper">
                <div class="process" :style="{ '--i': faultStatus['maintain'] / faultStatus.faultTotal || 0 }"></div>
              </span>
              <em class="count">{{ faultStatus['maintain'] }}</em>
            </div>
          </div>
        </div>
        <div class="flow chart">
          <div class="header">
            <h1 class="title">母管瞬时流量曲线</h1>
            <span class="unit">Nm³/min</span>
            <img src="../../../../assets/stationunitbox.jpg" alt="" />
          </div>
          <div class="chart_wrapper" id="flowChart"></div>
        </div>
        <div class="pressure chart">
          <div class="header">
            <h1 class="title">母管瞬时压力曲线</h1>
            <span class="unit">Bar</span>
            <img src="../../../../assets/stationunitbox.jpg" alt="" />
          </div>
          <div class="chart_wrapper" id="pressureChart"></div>
        </div>
        <div class="column">
          <div class="avgConsumption chart">
            <div class="header">
              <h1 class="title">单耗</h1>
              <div class="unit">kWh/Nm³</div>
              <img src="../../../../assets/stationunitbox.jpg" alt="" />
            </div>
            <div class="chart_wrapper" id="avgConsumptionChart"></div>
          </div>
          <div class="electricity chart">
            <div class="header">
              <h1 class="title">用电量</h1>
              <div class="unit">kWh</div>
              <img src="../../../../assets/stationunitbox.jpg" alt="" />
            </div>
            <div class="chart_wrapper" id="electricityChart"></div>
          </div>
          <div class="flowC chart">
            <div class="header">
              <h1 class="title">用气量</h1>
              <div class="unit">Nm³</div>
              <img src="../../../../assets/stationunitbox.jpg" alt="" />
            </div>
            <div class="chart_wrapper" id="flowCChart"></div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Konva from 'konva'
import deviceGroupApi from "@/api/device-group"
import moment from 'moment'
import warningApi from "@/api/warning"
import { deviceApi } from '@/api/station'
import {
  AddDatetimeToAnim
} from '@/views/EquipmentManager/EquipmentGroupDetail/konva-util'
import { websocketUrl } from "@/plugins/service"
import { getDeviceGroup, getDevicesStatus, getMonthReport } from '@/api/device'

export default {
  props: {
    changeComponent: Function
  },
  data () {
    return {
      runningStatus: {
        'online': 0,
        '待机': 0,
        'offline': 0,
        runningTotal: 0
      },
      faultStatus: {
        '预警': 0,
        'error': 0,
        'maintain': 0,
        faultTotal: 0
      },
      webSocket: {},
      dataShow: false,
      widgetShow: false
    }
  },
  created () {
    this.ratio = 1920 / 1080
    this.flowLineXAxis = []
    this.pressureLineXAxis = []
    this.avgConsumptionLineXAxis = []
    this.setDate()
    this.isYAxisLabelShow = true
    this.xAxisLabelStartIndex = 0
  },
  async mounted () {
    const { data } = await getDeviceGroup(this.$route.query.id)
    
    const chartsStatus = data.extraProperty?.model || []
    this.dataShow = chartsStatus.includes("2")
    this.widgetShow = chartsStatus.includes("1")
    this.flexible()
    this.loadStageData(this.$route.query.id).then(async () => {
      this.initialPieChart()
      this.initialLineChart('flowChart')
      this.initialLineChart('pressureChart')
      this.initialLineChart('avgConsumptionChart')
      this.initialBarChart('electricityChart')
      this.initialBarChart('flowCChart')
      try {
        await this.getStationInfo()
        await this.getData()
      } catch(e) {
        console.log(e);
      }
      const el = this.$refs.container
      this.w = (window.innerWidth - el.offsetLeft - 20) < 1200 ? 1200 : (window.innerWidth - el.offsetLeft - 20)
      this.h = Math.ceil(this.w / this.ratio)
      el.style.width = this.w + 'px'
      el.style.height = this.h + 'px'
      if (this.stage) {
        this.stage.width(this.w)
        this.stage.height(this.h)
        this.resize()
        this.connectWebSocket()
      } else {
        this.$refs.preview.style.width = this.w + 'px'
        this.$refs.preview.style.height = this.h - 52 + 'px'
        this.$refs.preview.style.backgroundColor = '#000034'
      }
    })
    document.addEventListener("fullscreenchange", this.handleFullscreenchange)
  },
  beforeDestroy () {
    for (let i in this.webSocket) {
      this.webSocket[i].close()
    }
    this.runningState?.dispose()
    this.flowChart?.dispose()
    this.pressureChart?.dispose()
    this.avgConsumptionChart?.dispose()
    this.electricityChart?.dispose()
    this.flowCChart?.dispose()
    clearTimeout(this.timer)
    document.removeEventListener('fullscreenchange', this.handleFullscreenchange)
  },
  destroyed () {
    this.webSocket = null
    this.runningStatus = null
    this.flowCChart = null
    this.pressureChart = null
    this.avgConsumptionChart = null
    this.electricityChart = null
    this.flowCChart = null
    this.timer = null
  },
  methods: {
    flexible() {
      const docEl = document.documentElement
      const dpr = window.devicePixelRatio || 1
      this.setBodyFontSize(dpr)
      this.setRemUnit(docEl)
    },
    setBodyFontSize(dpr) {
      if(document.body) {
        document.body.style.fontSize = (12 * dpr) + "px"
      } else {
        document.addEventListener("DOMContentLoaded", this.setBodyFontSize(dpr))
      }
    },
    setRemUnit(docEl, isFullScreen) {
      let rem
      if(isFullScreen) {
        rem = window.innerWidth / 20
        if(window.innerWidth <= 1680) {
          this.maxLength = 30
        }
      }
      else {
        if(window.innerWidth <= 1024) {
          this.maxLength = 16
          this.chartFontSize = 11
          this.isYAxisLabelShow = false
          this.xAxisLabelStartIndex = 5
        } else if(window.innerWidth <= 1440) {
          this.maxLength = 18
          this.chartFontSize = 14
          this.isYAxisLabelShow = false
        } else if(window.innerWidth <= 1680) {
          this.maxLength = 15
          this.chartFontSize = 15
        }
        rem = (window.innerWidth < 1440 ? 1440 : window.innerWidth) / 20
      }
      docEl.style.fontSize = rem + "px"
    },
    setFullscreen() {
      this.$refs.container.requestFullscreen()
    },
    setDate () {
      const now = +new Date()
      const start = now - 6 * 24 * 3600000
      this.startDate = moment(start).format('YYYY-MM-DD')
      this.endDate = moment(now).format('YYYY-MM-DD')
      this.startTime = +new Date(new Date().toLocaleString().split(' ')[0])
      this.endTime = +new Date()
    },
    async getStationInfo () {
      this.stations[Symbol.asyncIterator] = () => {
        let index = 0
        const vue = this,
              { startDate, endDate } = this,
              { stations } = vue
        return {
          next() {
            if (index > stations.length - 1) {
              return Promise.resolve({ done: true })
            }
            return new Promise(async resolve => {
              try {
                const item = stations[index++]
                // const deviceState = await deviceGroupApi.getDeviceState(item)
                const deviceState = await getDevicesStatus(item)
                const stationInfo = await getDeviceGroup(item)
                const deviceCodes = (stationInfo.data.extraProperty.devicesList || []).map(d => d.code)
                console.log(index);
                let data = []
                if (deviceCodes.length > 0) {
                  const statistics = await getMonthReport(startDate, endDate, deviceCodes + '')
                  data = statistics.data.slice(0, -1)
                }
                for (let i in vue.runningStatus) {
                  vue.runningStatus[i] += deviceState.data[i] || 0
                  vue.runningStatus.runningTotal += deviceState.data[i] || 0
                }
                for (let i in vue.faultStatus) {
                  vue.faultStatus[i] += deviceState.data[i] || 0
                  vue.faultStatus.faultTotal += deviceState.data[i] || 0
                }
                console.log(vue.runningStatus, vue.faultStatus);
                let pressureSetter = stationInfo.data.pressure?.split('+') || []
                pressureSetter = pressureSetter.map(item => {
                  return item.trim().split('.')[0].slice(2)
                })
                resolve({
                  value: {
                    id: item,
                    stationCode: stationInfo.data.code,
                    stationName: stationInfo.data.name,
                    pressureSetter,
                    data
                  },
                  done: false
                })
              } catch(e) {
                console.log(e);
                resolve({
                  value: null,
                  done: false
                })
              }
            })
          }
        }
      }
    },
    async getData () {
      console.log(123456);
      const colors = ["#80FFA5", "#00DDFF", "#37A2FF"]
      let index = 0
      let flag = true
      for (let i in this.runningStatus) {
        this.runningStatus[i] = 0
      }
      for (let i in this.faultStatus) {
        this.faultStatus[i] = 0
      }
      for await (let i of this.stations) {
        console.log(i);
        this[i.id] = {
          stationName: i.stationName,
          pressureSetter: i.pressureSetter,
          pressure: [],
          flow: [],
          color: colors[index++],
          data: i.data,
          avgConsumptionList: [],
          electricity: [],
          flowC: []
        }
        // const { startTime, endTime } = this
        // const params = {
        //   startTime,
        //   endTime,
        //   stationId: i.id
        // }
        // const { data } = await warningApi.getWarningRecordList(params)
        // this.faultStatus['预警'] += data.length
        // this.faultStatus.faultTotal += data.length
        if (i.data.length > 0) {
          if (flag) {
            console.log(i.data);
            flag = false
            this.avgConsumptionLineXAxis = []
            
            i.data.forEach(d => {
              this.avgConsumptionLineXAxis.push(d.datetime.slice(this.xAxisLabelStartIndex))
            })
          }
          i.data.forEach(d => {
            this[i.id].avgConsumptionList.push(d.avgGasConsumption)
            this[i.id].electricity.push(d.electricity)
            this[i.id].flowC.push(d.flow)
          })
          const labels = this.stage.find('.label')
          console.log(i, labels);
          const label = labels.find(label => label.attrs.text === i.stationName)
          const group = label.getParent()
          const values = group.find('.dataValue')
          const u = i.data.at(-1)
          values[0].text(u.electricity)
          values[1].text(u.flow)
          values[2].text(u.avgGasConsumption)
        }
      }
      console.log(123456);
      this.renderConsumptionChart()
      this.renderBarChart('electricityChart')
      this.renderBarChart('flowCChart')
      this.renderPieChart()
      this.timer = setTimeout(this.getData, 10 * 60 * 1000)
    },
    loadStageData (id) {
      return getDeviceGroup(id)
        .then(({ data }) => {
          const container = document.getElementById('preview')
          const i = JSON.parse(data.content)
          const c = data.extraProperty
          let content = i?.hasOwnProperty('unit') ? i.unit : false
          this.unitShow = c.stations?.length > 0
          this.stations = c.stations || []
          if (content) {
            this.stage = Konva.Node.create(content, 'preview')
            this.stage.x(0)
            this.stage.y(0)
            this.stage.offsetX(0)
            this.stage.offsetY(0)
            this.stage.scale({
              x: 1,
              y: 1
            })
            container.style.backgroundColor = this.stage.attrs.backgroundColor
            this.stage.draggable(false)
            this.setDraggable(this.stage, false)
            this.stage.find(node => {
              if (node.attrs.name === 'img') {
                const img = new Image()
                img.src = node.attrs.url
                img.onload = () => {
                  node.attrs.image = img
                }
              }
            })
            this.stage.find('.datetime').forEach(node => {
              AddDatetimeToAnim(node)
            })
          }
        })
    },
    setDraggable (node, draggable) {
      if (typeof node.getChildren === 'function') {
        const children = node.getChildren()
        if (children.length !== 0) {
          children.forEach(node => {
            node.draggable(draggable)
            this.setDraggable(node, draggable)
          })
        }
      }
    },
    resize () {
      const { stage } = this
      const layer = stage.getChildren()[0]
      let group = this.getBasicGroup(layer)
      const scaleX = stage.width() / group.width
      const scaleY = stage.height() / group.height
      const scale = scaleX < scaleY ? scaleX : scaleY
      layer.scale({
        x: scale,
        y: scaleY
      })

      group = this.getBasicGroup(layer)

      layer.offsetX(-(stage.width() - group.width) / 2)
      layer.offsetY(-(stage.height() - group.height) / 2)

      this.runningState?.resize()
      this.flowChart?.resize()
      this.pressureChart?.resize()
      this.avgConsumptionChart?.resize()
      this.electricityChart?.resize()
      this.flowCChart?.resize()
    },
    getBasicGroup(layer) {
      const stage = layer.getStage()
      const nodes = layer.getChildren().filter(node => node.name() !== "transformer")

      let minX, minY, maxX, maxY
      minX = minY = Infinity
      maxX = maxY = -Infinity
      nodes.forEach(node => {
        const rect = node.getClientRect({
          relativeTo: stage
        })
        minX = rect.x < minX ? rect.x : minX
        minY = rect.y < minY ? rect.y : minY
        maxX = (rect.x + rect.width > maxX) ? (rect.x + rect.width) : maxX
        maxY = (rect.y + rect.height > maxY) ? (rect.y + rect.height) : maxY
      })

      const group = {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
      }

      layer.move({
        x: -group.x,
        y: -group.y
      })

      return group
    },
    handleFullscreenchange() {
      const el = this.$refs.container
      if(this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      const isFullScreen = document.fullscreenElement !== null
      if(isFullScreen) {
        el.style.width = window.innerWidth + "px"
        el.style.height = window.innerWidth * 1080 / 1920 + "px"
        this.setRemUnit(document.documentElement, true)
      } else {
        el.style.width = this.w + "px"
        el.style.height = this.h + "px"
        this.setRemUnit(document.documentElement)
      }
      clearTimeout(this.timer)
      this.resizeTimer = setTimeout(() => {
        this.loadStageData(this.$route.query.id).then(async () => {
          this.stage.width(+el.style.width.slice(0, -2))
          if(isFullScreen) {
            if(el.style.height.slice(0, -2) > window.innerHeight) {
              this.stage.height(+el.style.height.slice(0, -2))
              el.style.height = window.innerHeight + "px"
              el.style.overflowY = "auto"
              el.style.overflowX = "hidden"
            } else {
              el.style.height = window.innerWidth * 1080 / 1920 + "px"
              this.stage.height(+el.style.height.slice(0, -2))
              el.style.overflowY = "unset"
              el.style.overflowX = "unset"
            }
          } else {
            this.stage.height(+el.style.height.slice(0, -2))
            el.style.overflowY = "unset"
            el.style.overflowX = "unset"
          }
          this.resize()
          let flag = true
          for await (let i of this.stations) {
            console.log(i);
            this[i.id].data = i.data
            if (i.data.length > 0) {
              if (flag) {
                flag = false
                this.avgConsumptionLineXAxis = []
                i.data.forEach(d => {
                  this.avgConsumptionLineXAxis.push(d.datetime.slice(this.xAxisLabelStartIndex))
                })
              }
              i.data.forEach(d => {
                this[i.id].avgConsumptionList.push(d.avgGasConsumption)
                this[i.id].electricity.push(d.electricity)
                this[i.id].flowC.push(d.flow)
              })
              const labels = this.stage.find('.label')
              const label = labels.find(label => label.attrs.text === i.stationName)
              const group = label.getParent()
              const values = group.find('.dataValue')
              const u = i.data.at(-1)
              values[0].text(u.electricity)
              values[1].text(u.flow)
              values[2].text(u.avgGasConsumption)
            }
          }
        })
      }, 100)
    },
    renderPieChart () {
      this.optionOfPieChart.series[0].data = [
        { 
          value: this.runningStatus['online'],
          name: '在线',
          itemStyle: {
            color: '#01c7a2'
          }
        },
        { 
          value: this.runningStatus['待机'],
          name: '待机',
          itemStyle: {
            color: '#0c86fb'
          }
        },
        { 
          value: this.runningStatus['offline'],
          name: '离线' ,
          itemStyle: {
            color: '#374659'
          }
        }
      ]
      this.runningState.setOption(this.optionOfPieChart)
    },
    initialPieChart () {
      this.runningState = this.$echarts.init(document.getElementById('runningState'))
      this.optionOfPieChart = {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            radius: ['70%', '88%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              fontSize: 18,
              color: '#fff',
              formatter: () => {
                return this.runningStatus.runningTotal + '台'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { 
                value: this.runningStatus['online'],
                name: '在线',
                itemStyle: {
                  color: '#01c7a2'
                }
              },
              { 
                value: this.runningStatus['待机'],
                name: '待机',
                itemStyle: {
                  color: '#0c86fb'
                }
              },
              { 
                value: this.runningStatus['offline'],
                name: '离线' ,
                itemStyle: {
                  color: '#374659'
                }
              }
            ]
          }
        ]
      }
      this.runningState.setOption(this.optionOfPieChart)
    },
    setFlowSeries () {
      const series = []
      this.stations.forEach(station => {
        const option = {
          name: this[station].stationName,
          type: 'line',
          stack: 'Total',
          symbol: 'none',
          smooth: true,
          data: this[station].flow,
          // data: getRandomData(),
          lineStyle: {
            color: this[station].color
          },
          itemStyle: {
            color: this[station].color
          },
          areaStyle: {
            opacity: .6,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: this[station].color
              },
              {
                offset: 1,
                color: "#061e3c"
              }
            ])
          }
        }
        series.push(option)
      })
      return series
    },
    setPressureSeries () {
      const series = []
      this.stations.forEach(station => {
        const option = {
          name: this[station].stationName,
          type: 'line',
          stacK: 'Total',
          symbol: 'none',
          smooth: true,
          data: this[station].pressure,
          // data: getRandomData(),
          lineStyle: {
            color: this[station].color
          },
          itemStyle: {
            color: this[station].color
          },
          areaStyle: {
            opacity: .6,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: this[station].color
              },
              {
                offset: 1,
                color: "#061e3c"
              }
            ])
          }
        }
        series.push(option)
      })
      return series
    },
    renderConsumptionChart () {
      const series = []
      this.stations.forEach(station => {
        console.log(this[station]);
        const option = {
          name: this[station].stationName,
          type: 'line',
          stacK: 'Total',
          symbol: 'none',
          smooth: true,
          data: this[station].avgConsumptionList || [],
          lineStyle: {
            color: this[station].color
          },
          itemStyle: {
            color: this[station].color
          },
          areaStyle: {
            opacity: .6,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: this[station].color
              },
              {
                offset: 1,
                color: "#061e3c"
              }
            ])
          }
        }
        series.push(option)
      })
      const option = JSON.parse(JSON.stringify(this.optionOfLineChart))
      option.xAxis.axisLabel = {
        show: true,
        align: 'center',
        rotate: 45,
        margin: 40,
        fontSize: 12
      }
      option.grid = {
        top: '8%',
        bottom: '-10%',
        left: this.isYAxisLabelShow ? '3%': '10%',
        right: this.isYAxisLabelShow ? '8%': '10%',
      }
      option.xAxis.data = this.avgConsumptionLineXAxis
      option.series = series
      this.avgConsumptionChart.setOption(option)
      console.log(option);
    },
    initialLineChart (id) {
      this[id] = this.$echarts.init(
        document.getElementById(id),
        null,
        {
          renderer: 'canvas',
          useDirtyRect: false
        }
      )
      this.optionOfLineChart = {
        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: "13%",
          bottom: "5%",
          left: this.isYAxisLabelShow ? '3%': '6%',
          right: '6%',
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: [],
          boundaryGap: false,
          axisLabel: {
            show: true,
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            inside: true
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: this.isYAxisLabelShow
          },
          splitLine: {
            show: false
          }
        },
        series: []
      }
      this[id].setOption(this.optionOfLineChart)
    },
    initialBarChart (id) {
      this[id] = this.$echarts.init(
        document.getElementById(id),
        null,
        {
          renderer: 'canvas',
          useDirtyRect: false
        }
      )
      this.optionOfBarChart = {
        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: "10%",
          bottom: "3%",
          left: '3%',
          right: '6%',
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: [],
          boundaryGap: true,
          axisLabel: {
            show: true,
            align: 'center',
            rotate: 45,
            margin: 36
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            inside: true,
            alignWithLabel: true
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: this.isYAxisLabelShow
          },
          splitLine: {
            show: false
          }
        },
        series: []
      }
      this[id].setOption(this.optionOfBarChart)
    },
    renderBarChart (id) {
      const type = id.slice(0, -5)
      const series = []
      this.stations.forEach(station => {
        const option = {
          name: this[station].stationName,
          type: 'bar',
          data: this[station][type] || [],
          barWidth: Math.ceil(100 / this.stations.length) + '%',
          lineStyle: {
            color: this[station].color
          },
          itemStyle: {
            color: this[station].color
          }
        }
        series.push(option)
      })
      this.optionOfBarChart.xAxis.data = this.avgConsumptionLineXAxis
      this.optionOfBarChart.series = series
      this[`${type}Chart`].setOption(this.optionOfBarChart)
    },
    connectWebSocket () {
      const authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      this.stations.forEach(stationCode => {
        this.webSocket[stationCode] = new WebSocket(`wss://ygk.deman.cn:9006/ws/device/group/${this.$route.query.id}?token=${authorization}`)
        this.webSocket[stationCode].onmessage = e => {
          const record = JSON.parse(e.data)
          if (!record.device_code) {
            if (record.flow) {
              if (this.flowLineXAxis.length > 100) {
                this.flowLineXAxis.shift()
                this[stationCode].flow.shift()
              }
              const time = moment(+new Date()).format("HH:mm:ss")
              if (!this.flowLineXAxis.find(item => time === item)) {
                this.flowLineXAxis.push(time)
              }
              this[stationCode].flow.push(record.flow)
              this.optionOfLineChart.xAxis.data = this.flowLineXAxis
              this.optionOfLineChart.series = this.setFlowSeries()
              this.flowChart.setOption(this.optionOfLineChart)
            }
          } else if (this[stationCode].pressureSetter.includes(record.device_code)) {
            if (this.pressureLineXAxis.length > 100) {
              this.pressureLineXAxis.shift()
              this[stationCode].pressure.shift()
            }
            if (this[stationCode].pressureSetter.includes(record.device_code)) {
              const time = moment(+new Date()).format("HH:mm:ss")
              if (!this.pressureLineXAxis.find(item => time === item)) {
                this.pressureLineXAxis.push(time)
              }
              this[stationCode].pressure.push(record.mu_Pressure)
              this.optionOfLineChart.xAxis.data = this.pressureLineXAxis
              this.optionOfLineChart.series = this.setPressureSeries()
              this.pressureChart.setOption(this.optionOfLineChart)
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
li {
  list-style: none;
}
em {
  font-style: normal;
}
.container {
  position: relative;
}
.models {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  transform: translateY(-100%);
  background-color: #07172a;
}
.container {
  background-color: rgba(7, 23, 42, .5);
}
#preview {
  width: 100%;
  height: 100%;
  // background: url('../../../../assets/stationunitbg.png') no-repeat;
  background-position: 50% 40%;
  background-size: 146% 100%;
  .title {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 20%;
    // background: url('../../../../assets/titlebg.png') 0 0 /contain no-repeat;
    h1 {
      font-size: .3125rem;
      color: #fff;
      text-align: center;
      font-weight: 900;
      margin-top: .5%;
    }
  }
}
.content {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // background-color: rgba(255, 255, 255, .5);
  & > div {
    position: absolute;
    // background-color: rgba(7, 23, 42, .5);
    .header {
      position: relative;
      width: 100%;
      height: 50px;
      .title {
        position: absolute;
        top: 50%;
        left: 10%;
        transform: translateY(-50%);
        font-size: .1875rem;
        font-weight: 500;
        color: #fff;
      }
      .unit {
        position: absolute;
        top: 50%;
        left: 40%;
        transform: translateY(-50%);
        color: #bdc8d5;
        font-size: .1667rem;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .container {
      width: 100%;
      height: 100%;
      display: flex;
    }
  }
  .chart {
    display: flex;
    flex-direction: column;
    background-color: rgba(7, 23, 42, .5);
    .chart_wrapper {
      flex: 1;
    }
  }
}
.running_status {
  top: 9%;
  left: 1%;
  width: 22%;
  height: 35%;
  .pie {
    display: flex;
    height: 50%;
    padding-top: 5%;
    div {
      flex: 1;
    }
    .description span {
      margin: 0 10px;
    }
    .description strong {
      font-size: .1875rem;
      margin-left: 10px;
    }
  }
  ul {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  li {
    flex: 1;
    font-size: .1667rem;
    color: #fff;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      width: 16px;
      height: 16px;
      margin-right: 15px;
    }
  }
  li:nth-child(1)::before {
    background-color: #01c7a2;
  }
  li:nth-child(2)::before {
    background-color: #0c86fb;
  }
  li:nth-child(3)::before {
    background-color: #374659;
  }
  .footer {
    width: 100%;
    margin-top: 20px;
    img {
      width: 100%;
    }
  }
}
.fault {
  top: 46%;
  left: 1%;
  width: 22%;
  height: 20%;
  .container {
    padding: 20px 10px;
    flex-direction: column;
    justify-content: space-between;
  }
  .col {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: .1667rem;
    color: #fff;
    padding: 0 .0521rem 0 .2083rem;
    .name {
      width: 24%;
    }
    .process-wrapper {
      width: 50%;
      height: .1563rem;
      border: 1px solid #142e4e;
    }
    em {
      font-size: .1875rem;
      font-weight: 700;
    }
    .process {
      width: calc(var(--i) * 100%);
      height: 100%;
      background-color: #157fff;
    }
  }
  img {
    width: 30px;
    height: 30px;
  }
}
.flow,
.pressure {
  bottom: 5%;
  left: 1%;
  width: 36%;
  height: 20%;
}
.pressure {
  left: 39%;
}
.avgConsumption {
  right: 1%;
  top: 8%;
  width: 22%;
  height: 26%;
}
.electricity {
  right: 1%;
  top: 37%;
  width: 22%;
  height: 28%;
}
.flowC {
  right: 1%;
  bottom: 5%;
  width: 22%;
  height: 28%;
}
.column {
  position: absolute;
  top: 8%;
  bottom: 5%;
  right: 1%;
  width: 22%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .chart {
    width: 100%;
    height: calc(33% - 10px);
  }
}
@media screen and (max-width: 1440px) {
  .w {
    overflow-x: auto;
  }
}
.scroll_wrapper {
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>